import { INavigator, IWindow, Logger } from "oidc-client-ts";
import { PopupCallBackType } from "../../services/iamService";

export class IamMobileSdkPopupNavigator implements INavigator {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    private readonly _logger = new Logger("RedirectNavigator");

    constructor(private readonly samlLogin: PopupCallBackType) {}

    prepare(): Promise<IWindow> {
        this._logger.create("prepare");
        let targetWindow = window.self as Window;

        let abort: (reason: Error) => void;
        return {
            navigate: async (params) => {
                this._logger.create("navigate");
                return this.samlLogin(params.url);
            },
            close: () => {
                this._logger.create("close");
                abort?.(new Error("Redirect aborted"));
                targetWindow.stop();
            }
        } as unknown as Promise<IWindow>;
    }

    callback(): Promise<void> {
        return Promise.resolve();
    }
}